export const enum OperationAccess {
  ManageMerchantAccounts = 'manage_merchant_accounts',
  ManageMerchantCredentials = 'manage_merchant_credentials',
}
